import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Dropdown, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';

import './style.css';
import getApiVersion from '../../../../_helpers/api-version';

export default function DownloadLink({ telehealth, small, block, icon = true }) {
  const clientId = useSelector(state => state.client.id);
  const authToken = useSelector(state => state.authentication.token);

  let url = `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/download`;
  url += `?access_token=${authToken}&x-axs-version=${process.env.REACT_APP_API_VERSION}&x-axs-platform=${process.env.REACT_APP_PLATFORM}`;

  const variantClass = classNames(
    { 'primary': !icon },
    { 'outline-primary': icon },
    { 'btn-sm': small ?? false },
  );

  const dropDownClass = classNames({
    'btn-block': block ?? false
  });

  return <OverlayTrigger
    placement="top"
    overlay={<Tooltip>Download</Tooltip>}
  >

    <Dropdown className={dropDownClass} as={ButtonGroup}>
      <Dropdown.Toggle id="download-toggle" variant={variantClass}>
        {icon ? <i className="fa fa-download" aria-hidden="true"></i> : "Download"}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href={`${url}&type=word`}>Word Doc</Dropdown.Item>

        {parseInt(clientId) === 1 && <>
          <Dropdown.Divider />
          <Dropdown.Item href={`${url}&type=practice_partners`}>Practice Partners</Dropdown.Item>
        </>
        }
      </Dropdown.Menu>
    </Dropdown>
  </OverlayTrigger>

}